import type { DataRow } from "../types";

export type BranchDirectoryEntry = {
  number: string;
  shortName: string;
  fullName: string;
};

/**
 * ทะเบียนสำนักงานสาขา อ้างอิงจาก branch_number_name.txt ฉบับที่ผู้ใช้ปรับปรุง
 * เมื่อ 11 ต.ค. 2569 โดยเลขสาขาตรงกับเลขสองหลักแรกของรหัส DMA
 */
export const BRANCHES: readonly BranchDirectoryEntry[] = [
  { number: "01", shortName: "สสบ.", fullName: "สำนักงานประปาสาขาบางกอกน้อย" },
  { number: "02", shortName: "สสต.", fullName: "สำนักงานประปาสาขาตากสิน" },
  { number: "03", shortName: "สสญ.", fullName: "สำนักงานประปาสาขาพญาไท" },
  { number: "04", shortName: "สสน.", fullName: "สำนักงานประปาสาขานนทบุรี" },
  { number: "05", shortName: "สสท.", fullName: "สำนักงานประปาสาขาทุ่งมหาเมฆ" },
  { number: "06", shortName: "สสม.", fullName: "สำนักงานประปาสาขาแม้นศรี" },
  { number: "07", shortName: "สสส.", fullName: "สำนักงานประปาสาขาสุขุมวิท" },
  { number: "11", shortName: "สสภ.", fullName: "สำนักงานประปาสาขาภาษีเจริญ" },
  { number: "12", shortName: "สสล.", fullName: "สำนักงานประปาสาขาลาดพร้าว" },
  { number: "13", shortName: "สสพ.", fullName: "สำนักงานประปาสาขาพระโขนง" },
  { number: "14", shortName: "สสว.", fullName: "สำนักงานประปาสาขาสุขสวัสดิ์" },
  { number: "15", shortName: "สสช.", fullName: "สำนักงานประปาสาขาประชาชื่น" },
  { number: "16", shortName: "สสข.", fullName: "สำนักงานประปาสาขาบางเขน" },
  { number: "17", shortName: "สสป.", fullName: "สำนักงานประปาสาขาสมุทรปราการ" },
  { number: "53", shortName: "สสมบ.", fullName: "สำนักงานประปาสาขามีนบุรี" },
  { number: "54", shortName: "สสบท.", fullName: "สำนักงานประปาสาขาบางบัวทอง" },
  { number: "55", shortName: "สสสภ.", fullName: "สำนักงานประปาสาขาสุวรรณภูมิ" },
  { number: "56", shortName: "สสมส.", fullName: "สำนักงานประปาสาขามหาสวัสดิ์" },
] as const;

const BRANCH_BY_NUMBER = new Map(BRANCHES.map((branch) => [branch.number, branch]));

export function branchNumberFromDma(dmaCode: string | null | undefined): string | null {
  const digits = String(dmaCode ?? "").replace(/\D/g, "");
  if (digits.length < 2) return null;
  const number = digits.slice(0, 2);
  return BRANCH_BY_NUMBER.has(number) ? number : null;
}

export function branchByNumber(number: string | null | undefined): BranchDirectoryEntry | null {
  const normalized = String(number ?? "").replace(/\D/g, "").padStart(2, "0").slice(-2);
  return BRANCH_BY_NUMBER.get(normalized) ?? null;
}

export function branchForDma(dmaCode: string | null | undefined): BranchDirectoryEntry | null {
  return branchByNumber(branchNumberFromDma(dmaCode));
}

export function enrichRowWithBranch(row: DataRow): DataRow {
  const branch = branchForDma(row.dmaCode);
  return {
    ...row,
    branchNumber: branch?.number ?? null,
    branchShortName: branch?.shortName ?? null,
    branchFullName: branch?.fullName ?? null,
  };
}
